import { render, staticRenderFns } from "./ShopTemplate.vue?vue&type=template&id=08ba6b05&scoped=true&"
import script from "./ShopTemplate.vue?vue&type=script&lang=js&"
export * from "./ShopTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ShopTemplate.vue?vue&type=style&index=0&id=08ba6b05&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba6b05",
  null
  
)

export default component.exports